<template>
  <div class="home-page-wrapper">
    <!-- <TopNotice /> -->
    <MarketingNotice />
    <div class="home-page-carousel">
      <HeadBanner />
    </div>

    <div class="home-page-introduce">
      <div class="introduce-t1">
        <img
          v-if="i18n.locale === 'en_US'"
          src="@/assets/images/new-logo-visa2.png"
          alt="introduce"
        />
        <img
          v-if="i18n.locale === 'fr_CA'"
          src="@/assets/images/new-logo-visa2-fr.png"
          alt="introduce"
        />
        <!--        <span>{{ $t('program') }}</span>-->
      </div>
      <div class="introduce-t2">
        <p role="dragonPass introduce">
          <i18n-t keypath="dragonpass-desc1" tag="p">
            <router-link to="/terms" target="_blank" class="tc-link"
              >{{ $t('select-visa-cardholders') }}
            </router-link>
          </i18n-t>
          <!-- (<a href="#" role="link"> {{ $t('dragonpass-desc1link') }} </a>). -->
        </p>

        <p role="dragonPass introduce">
          <i18n-t keypath="dragonpass-desc2" tag="p">
            <span v-if="isLogin">{{ $t('enroll') }}</span>
            <router-link v-else to="/sign-up" class="tc-link">{{ $t('enroll') }}</router-link>
          </i18n-t>
        </p>
        <!-- <p role="dragonPass introduce">
          <i18n-t keypath="dragonpass-desc3" tag="p">
            <span v-if="isLogin">{{ $t('enroll-now') }}</span>
            <router-link v-else to="/sign-up" class="tc-link">{{ $t('enroll-now') }} </router-link>
          </i18n-t>
        </p> -->
      </div>
    </div>

    <div class="home-page-service">
      <!-- Lounges -->
      <div class="airport-lounge">
        <airport-lounge-card
          :options="lounge"
          @viewMore="handleViewMore"
          @cardClick="handleCardClick"
        ></airport-lounge-card>

        <!-- Dining Offers -->
        <airport-lounge-card
          :options="dining"
          @viewMore="handleViewMore"
          @cardClick="handleCardClick"
        ></airport-lounge-card>

        <!-- Retail Offers -->
        <airport-lounge-card
          :options="retail"
          @viewMore="handleViewMore"
          @cardClick="handleCardClick"
        ></airport-lounge-card>

        <!-- Visa Benefits -->
        <airport-lounge-card
          v-if="isLogin && benefits.cards.length > 0"
          :options="benefits"
          @viewMore="handleViewMore('visaBenefits')"
          @cardClick="goToBenefitDetail"
        ></airport-lounge-card>

        <!-- Visa Offers -->
        <airport-lounge-card
          v-if="isLogin && offers.cards.length > 0"
          :options="offers"
          @viewMore="handleViewMore('visaOffers')"
          @cardClick="goToOfferDetail"
        ></airport-lounge-card>
      </div>
    </div>
  </div>
</template>

<script>
  import i18n from '@/i18n';
  import AirportLoungeCard from '@/components/BaseUi/AirportLoungeCards';
  import HeadBanner from './Components/HeadBanner/index.vue';
  import TopNotice from './Components/TopNotice/index.vue';
  import { mapState } from 'vuex';
  import MarketingNotice from './Components/MarketingNotice/index.vue';
  import { getQueryString } from '@/utils';

  export default {
    name: 'Home',
    components: {
      AirportLoungeCard,
      HeadBanner,
      TopNotice,
      MarketingNotice,
    },

    computed: {
      ...mapState(['isLogin', 'userInfo', 'test']),
    },

    data() {
      return {
        i18n,
        lounge: {
          title: 'views-home-modules-lounge',
          subTitle: 'views-home-modules-lounge-more',
          showDesc2: true,
          useHomePageSize: true,
          cardItemStyle: {
            width: '25%',
          },
          cards: [],
          index: 'lounge',
        },

        dining: {
          title: 'views-home-modules-dining',
          subTitle: 'views-home-modules-dining-more',
          showDesc2: true,
          useHomePageSize: true,
          cardItemStyle: {
            width: '25%',
          },
          cards: [],
          index: 'dining',
        },

        retail: {
          title: 'views-home-modules-retail',
          subTitle: 'views-home-modules-retail-more',
          showDesc2: true,
          useHomePageSize: true,
          cardItemStyle: {
            width: '25%',
          },
          cards: [],
          index: 'retail',
        },

        benefits: {
          title: 'views-home-modules-benefits',
          subTitle: 'views-home-modules-benefits-more',
          showDesc2: true,
          useHomePageSize: true,
          cardItemStyle: {
            width: '25%',
          },
          cards: [],
          index: 'benefit',
        },

        offers: {
          title: 'views-home-modules-offers',
          subTitle: 'views-home-modules-offers-more',
          showDesc2: true,
          useHomePageSize: true,
          cardItemStyle: {
            width: '25%',
          },
          cards: [],
          index: 'offer',
        },
      };
    },

    mounted() {
      // this.$loginModal.showUpload();
      if (this.isLogin) {
        this.getHomePageBanner({ kind: 1, type: 'offers' });
        this.getHomePageBanner({ kind: 2, type: 'benefits' });
        this.getNotificationList();
      }

      this.getHomePageData();

      const payOrderNo = getQueryString('payOrderNo');
      if (payOrderNo) {
        const sourceModal = localStorage.getItem('sourceModal');
        if (sourceModal === 'addCardModal') {
          this.$loginModal.showAdd();
        } else if (sourceModal === 'updateCardModal') {
          this.$loginModal.showUpload();
        } else {
          // 如果没有指定来源, 说明已经被移除, 不需要处理
        }
        localStorage.removeItem('sourceModal');
      }
    },

    methods: {
      // 点击首页benefit，offer去往详情页
      goToBenefitDetail(data) {
        const { vmorcId } = data;
        data.kind === 2 && this.$router.push({ path: '/benefit/details', query: { vmorcId } });
      },
      // 点击首页offer去往详情页
      goToOfferDetail(data) {
        const { vmorcId } = data;
        data.kind === 1 && this.$router.push({ path: '/offer/details', query: { vmorcId } });
      },
      // 获取首页权益banner图
      async getHomePageBanner(data) {
        const { userId = '', sessionId = '' } = this.userInfo;
        const lang = this.$i18n.locale;
        try {
          const res = await this.$http.common.getHomePageBanner({
            ...data,
            userId,
            sessionId,
            lang,
          });
          if (res?.state === '11') {
            if (data.type === 'benefits') {
              this.benefits.cards = res.payload.slice(0, 3);
            }
            if (data.type === 'offers') {
              this.offers.cards = res.payload.slice(0, 3);
            }
          }
        } catch (e) {
          console.log('e', e);
        }
      },

      // 获取首页权益数据
      getHomePageData() {
        this.$loading.show();
        const data = {
          lang: this.$i18n.locale,
          userId: this.userInfo?.userId ?? '',
        };
        this.$http.common.getHomePageData(data).then(
          res => {
            if (res?.state === '11') {
              this.lounge.cards = res.payload.lounges.slice(0, 3);
              this.dining.cards = res.payload.dining.slice(0, 3);
              this.retail.cards = res.payload.retail.slice(0, 3);
              this.$loading.hide();
            } else {
              console.error(res?.note);
              this.$loading.hide();
            }
          },
          err => {
            console.error(err);
            this.$loading.hide();
          },
        );
      },

      // banner 跳转到signup页面
      handleSignUp() {
        this.$router.push('/sign-up');
      },

      // 卡片的view More被点击
      handleViewMore(data) {
        const lounges = data.includes('lounge');
        const dining = data.includes('dining');
        const retail = data.includes('retail');
        const benefits = data.includes('Benefit');
        const offers = data.includes('Offers');

        if (lounges) this.$router.push({ name: 'Lounges', params: { type: 1 } });
        if (dining) this.$router.push({ name: 'Dining', params: { type: 2 } });
        if (retail) this.$router.push({ name: 'Retail', params: { type: 3 } });
        if (benefits) this.$router.push({ name: 'Visabenefits' });
        if (offers) this.$router.push({ name: 'Visaoffers' });
      },
      // 首页卡片被点击
      handleCardClick(data) {
        if (data.productType === 1) {
          this.$router.push({
            path: '/lounge/details',
            query: { loungeId: data.id, loungeCode: data.code },
          });
        } else if (data.productType === 2) {
          this.$router.push({
            path: '/dining/details',
            query: { diningId: data.id, diningCode: data.code },
          });
        } else if (data.productType === 3) {
          this.$router.push({
            path: '/retail/details',
            query: { airportCode: data.airportCode, retailCodes: data.code },
          });
        }
      },
      getNotificationList() {
        const { userId = '', sessionId = '' } = this.userInfo;
        this.$http.common
          .getNotificationList({
            lang: this.$i18n.locale,
            userId,
            sessionId,
            device: 'web',
            pageNum: 1,
            pageSize: 10,
          })
          .then(
            res => {
              if (res?.state === '11') {
                this.$store.commit('setState', {
                  state: 'hasUnresdMsg',
                  values: res?.payload?.unreadCount > 0 || false,
                });
              } else {
                console.error(res?.note);
              }
            },
            err => {
              console.error(err);
            },
          );
      },
    },
  };
</script>
<style lang="scss" scoped>
  @use './index.scss';
  @use './mobile.scss';
</style>
